import React, { ReactNode } from 'react';
import { useDeviceType } from '@cian/ui-kit';

import cn from 'clsx';

import styles from './styles.css';

interface ICalculatorLayoutProps {
  header: ReactNode | undefined;
  content: ReactNode | undefined;
  footer: ReactNode | undefined;
}

export const CalculatorLayout: React.FC<ICalculatorLayoutProps> = ({ header, content, footer }) => {
  const deviceType = useDeviceType();

  return (
    <div className={cn(styles['root'], styles[deviceType])}>
      {header}
      <div className={cn(styles['content'], styles[deviceType])}>{content}</div>
      {footer}
    </div>
  );
};
